export default () => {
  // eslint-disable-next-line
  window.__VERSION__ = __VERSION__;
  // eslint-disable-next-line
  window.__COMMIT__ = __COMMIT__;
  // eslint-disable-next-line
  window.__BRANCH__ = __BRANCH__;
};
